import React from "react";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import { ArrowBack } from "@material-ui/icons";
import { primaryShade1, white } from "../styles/color";

const styles = {
  root: {
    flexGrow: 1
  }
};

class SimpleAppBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const { props } = this;

    return (
      <div className={styles.root}>
        <AppBar
          position="fixed"
          color="default"
          style={{
            boxShadow: "none",
            backgroundColor: primaryShade1
          }}
        >
          <Toolbar>
            {props.isShowAppBar ? null : props.appBarLeftIcon ? (
              <IconButton
                color="inherit"
                aria-label="Menu"
                onClick={e => {
                  e.preventDefault();
                  this.props.history.goBack();
                }}
              >
                <ArrowBack style={{ color: white }} />
              </IconButton>
            ) : null}
            <Typography
              variant="h6"
              style={{
                flexGrow: "1",
                textAlign: "center",
                color: white,
                marginLeft: "-28px"
              }}
            >
              {props.appBarTitle}
            </Typography>
          </Toolbar>
        </AppBar>
      </div>
    );
  }
}

SimpleAppBar.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withRouter(withStyles(styles)(SimpleAppBar));
